import React from 'react'
import { t } from '@lingui/macro'
import IconTrash from '../../../../components/common/icon/IconTrash'
import { useRemoveDashboardItemMutation } from './Controls.codegen'
import { DashboardItemTypes } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { ButtonIcon } from 'front-end/src/components'

interface IProps {
  dashboardId: number
  itemId: number
  itemType: DashboardItemTypes
  refetch: () => void
}

const Controls = ({ refetch, dashboardId, itemId, itemType }: IProps) => {
  const [removeItem] = useRemoveDashboardItemMutation()

  return (
    <div className="ItemsPane__controls">
      <div className="controls-inner">
        <ButtonIcon
          circular
          icon={<IconTrash />}
          hint={t`Delete`}
          aria-label={t`Delete`}
          onClick={async () => {
            await removeItem({
              variables: {
                dashboardId: dashboardId,
                itemId: itemId,
                itemType: itemType
              }
            })
            refetch()
          }}
        />
      </div>
    </div>
  )
}

export default Controls
